"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoyalMailFormat$ = exports.RoyalMailFormat$outboundSchema = exports.RoyalMailFormat$inboundSchema = void 0;
exports.royalMailFormatToJSON = royalMailFormatToJSON;
exports.royalMailFormatFromJSON = royalMailFormatFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.RoyalMailFormat$inboundSchema = z.object({
    building_name: z.nullable(z.string()),
    building_number: z.nullable(z.string()),
    department_name: z.nullable(z.string()),
    dependent_locality: z.nullable(z.string()),
    dependent_thoroughfare: z.nullable(z.string()),
    double_dependent_locality: z.nullable(z.string()),
    organisation_name: z.nullable(z.string()),
    post_town: z.nullable(z.string()),
    postcode: z.string(),
    sub_building_name: z.nullable(z.string()),
    thoroughfare: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "building_name": "buildingName",
        "building_number": "buildingNumber",
        "department_name": "departmentName",
        "dependent_locality": "dependentLocality",
        "dependent_thoroughfare": "dependentThoroughfare",
        "double_dependent_locality": "doubleDependentLocality",
        "organisation_name": "organisationName",
        "post_town": "postTown",
        "sub_building_name": "subBuildingName",
    });
});
/** @internal */
exports.RoyalMailFormat$outboundSchema = z.object({
    buildingName: z.nullable(z.string()),
    buildingNumber: z.nullable(z.string()),
    departmentName: z.nullable(z.string()),
    dependentLocality: z.nullable(z.string()),
    dependentThoroughfare: z.nullable(z.string()),
    doubleDependentLocality: z.nullable(z.string()),
    organisationName: z.nullable(z.string()),
    postTown: z.nullable(z.string()),
    postcode: z.string(),
    subBuildingName: z.nullable(z.string()),
    thoroughfare: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        buildingName: "building_name",
        buildingNumber: "building_number",
        departmentName: "department_name",
        dependentLocality: "dependent_locality",
        dependentThoroughfare: "dependent_thoroughfare",
        doubleDependentLocality: "double_dependent_locality",
        organisationName: "organisation_name",
        postTown: "post_town",
        subBuildingName: "sub_building_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RoyalMailFormat$;
(function (RoyalMailFormat$) {
    /** @deprecated use `RoyalMailFormat$inboundSchema` instead. */
    RoyalMailFormat$.inboundSchema = exports.RoyalMailFormat$inboundSchema;
    /** @deprecated use `RoyalMailFormat$outboundSchema` instead. */
    RoyalMailFormat$.outboundSchema = exports.RoyalMailFormat$outboundSchema;
})(RoyalMailFormat$ || (exports.RoyalMailFormat$ = RoyalMailFormat$ = {}));
function royalMailFormatToJSON(royalMailFormat) {
    return JSON.stringify(exports.RoyalMailFormat$outboundSchema.parse(royalMailFormat));
}
function royalMailFormatFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RoyalMailFormat$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RoyalMailFormat' from JSON`);
}
//# sourceMappingURL=royalmailformat.js.map